import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { ProtectedRoute } from "./protectedRoute.js";

import Login from "./pages/Login.js";

import PrCurrencyType from "./pages/admin/paymentReceipt/prCurrencyType.js";
import PrEventType from "./pages/admin/paymentReceipt/prEventType.js";
import PrOccupancyType from "./pages/admin/paymentReceipt/prOccupancyType.js";
import PrRegistrationType from "./pages/admin/paymentReceipt/prRegistrationType.js";
import PrPaymentType from "./pages/admin/paymentReceipt/prPaymentType.js";
import PrRegistrationCategory from "./pages/admin/paymentReceipt/prRegistrationCategory.js";
import PaymentReceiptReceived from "./pages/admin/paymentReceipt/paymentReceiptReceived.js";
import PaymentReceiptGenerated from "./pages/admin/paymentReceipt/paymentReceiptGenerated.js";
import PaymentReceiptPdf from "./pages/admin/paymentReceipt/paymentReceiptPdf.jsx";

import InvoiceReceiptReceived from "./pages/admin/invoiceReceipt/invoiceReceiptReceived.js";
import InvoiceReceiptGenerated from "./pages/admin/invoiceReceipt/invoiceReceiptGenerated.js";
import InvoiceRegType from "./pages/admin/invoiceReceipt/invoiceRegType.js";
import InvoiceInBank from "./pages/admin/invoiceReceipt/invoiceInBank.js";
import InvoiceUsBank from "./pages/admin/invoiceReceipt/invoiceUsBank.js";
import InvoiceReceiptPdf from "./pages/admin/invoiceReceipt/invoiceReceiptPdf.jsx";

import AbCategory from "./pages/admin/abstractReceipt/abCategory.js";
import AbstractType from "./pages/admin/abstractReceipt/abstractType.js";


import PendingProgramManager from "./pages/admin/abstractReceipt/pendingProgramManager.js";
import ApprovedProgramManager from "./pages/admin/abstractReceipt/approvedProgramManager.js";

import AllReviewers from "./pages/admin/abstractReceipt/allReviewers.js";
import ApprovedReviewers from "./pages/admin/abstractReceipt/approvedReviewers.js";
import PendingReviewers from "./pages/admin/abstractReceipt/pendingReviewers.js";


import EsVenue from "./pages/admin/defaultSetup/esVenue.js";
import EsSubjectType from "./pages/admin/defaultSetup/esSubjectType.js";
import EsCountries from "./pages/admin/defaultSetup/esCountries.js";
import EsSubdomainType from "./pages/admin/defaultSetup/esSubdomainType.js";
import EsSeriesType from "./pages/admin/defaultSetup/esSeriesType.js";

import PaidAccommodation from "./pages/admin/accommodationStatus/paidAccommodation.js";
import FreeAccommodation from "./pages/admin/accommodationStatus/freeAccommodation.js";

import ConferenceEvent from "./pages/admin/eventSetup/conferenceEvent.js";
import WebinarEvent from "./pages/admin/eventSetup/webinarEvent.js";

import RefundApproved from "./pages/admin/refundStatus/refundApproved.js";
import RefundPending from "./pages/admin/refundStatus/refundPending.js";

import TransactionStatus from "./pages/admin/transactionStatus/transactionStatus.js";

import RevenueAll from "./pages/admin/revenueStatus/revenueAll.js";
import RevenueConference from "./pages/admin/revenueStatus/revenueConference.js";
import RevenueWebinar from "./pages/admin/revenueStatus/revenueWebinar.js";

import Abstract from "./pages/admin/leadForms/abstract.js";
import Brochure from "./pages/admin/leadForms/brochure.js";
import Contact from "./pages/admin/leadForms/contact.js";
import PastconfProceedingsLists from "./pages/admin/leadForms/pastconfProceedingsLists.js";

//revenue forms
import Registration from "./pages/admin/revenueForms/registration.js";
import SelfRegistration from "./pages/admin/revenueForms/selfRegistration.js";
import PaypalTransactions from "./pages/admin/revenueForms/paypalTransactions.js";
import RazorpayTransactions from "./pages/admin/revenueForms/razorpayTransactions.js";


import ProgramManager from './pages/event/abstractReceipt/programManager.js';
import Abreviewers from './pages/event/abstractReceipt/abReviewers.js';
import AbstractReceipt from './pages/event/abstractReceipt/abstractReceipt.js';
import AbstractReceiptPdf from './pages/event/abstractReceipt/abstractReceiptPdf.jsx';

//payment receipt form
// import PaymentReceipt from './pages/admin/paymentReceiptForm/paymentReceipt.js';
// import Pdf from './pages/pdfGeneration/pdf.js';

//event lead forms
import EmBrochure from "./pages/event/emleadForms/embrochure.js";
import EmAbstract from "./pages/event/emleadForms/emabstract.js";
import EmContact from "./pages/event/emleadForms/emcontact.js";
import EmPastconfProceedingsLists from "./pages/event/emleadForms/empastconfProceedingsLists.js";

//event revenue forms
import EmRegistration from './pages/event/emrevenueForms/emregistration.js';
import EmSelfRegistration from './pages/event/emrevenueForms/emselfRegistration.js';

import PaymentReceipt from './pages/event/paymentReceiptForm/paymentReceipt.js';
import InvoiceReceipt from './pages/event/invoiceReceiptForm/invoiceReceipt.js';
import Refund from './pages/event/refundForms/refund.js';

import Accommodation from './pages/event/accommodationForm/accommodation.js';

import Dashboard from "./pages/event/dashboard/charts/dashboard.js";
import CmsUser from "./pages/admin/cmsUserCreationForms/cmsUser.js";
import MetaTags from "./pages/admin/seoConfig/metaTags.js";
import SeoContextPage from "./pages/admin/seoConfig/seoContextPage.js";


import Revenue from './pages/finance/revenueStatus/revenue.js';

import MgmtPrCurrencyType from "./pages/management/paymentReceipt/mgmtPrCurrencyType.js";
import MgmtPrEventType from "./pages/management/paymentReceipt/mgmtPrEventType.js";
import MgmtPrOccupancyType from "./pages/management/paymentReceipt/mgmtPrOccupancyType.js";
import MgmtPrRegistrationType from "./pages/management/paymentReceipt/mgmtPrRegistrationType.js";
import MgmtPrPaymentType from "./pages/management/paymentReceipt/mgmtPrPaymentType.js";
import MgmtPrRegistrationCategory from "./pages/management/paymentReceipt/mgmtPrRegistrationCategory.js";
import MgmtPaymentReceiptReceived from "./pages/management/paymentReceipt/mgmtPaymentReceiptReceived.js";
import MgmtPaymentReceiptGenerated from "./pages/management/paymentReceipt/mgmtPaymentReceiptGenerated.js";
import MgmtPaymentReceiptPdf from "./pages/management/paymentReceipt/mgmtPaymentReceiptPdf.jsx";

import MgmtInvoiceReceiptReceived from "./pages/management/invoiceReceipt/mgmtInvoiceReceiptReceived.js";
import MgmtInvoiceReceiptGenerated from "./pages/management/invoiceReceipt/mgmtInvoiceReceiptGenerated.js";
import MgmtInvoiceRegType from "./pages/management/invoiceReceipt/mgmtInvoiceRegType.js";
import MgmtInvoiceInBank from "./pages/management/invoiceReceipt/mgmtInvoiceInBank.js";
import MgmtInvoiceUsBank from "./pages/management/invoiceReceipt/mgmtInvoiceUsBank.js";
import MgmtInvoiceReceiptPdf from "./pages/management/invoiceReceipt/mgmtInvoiceReceiptPdf.jsx";

import MgmtRevenueAll from "./pages/management/revenueStatus/mgmtRevenueAll.js";
import MgmtRevenueConference from "./pages/management/revenueStatus/mgmtRevenueConference.js";
import MgmtRevenueWebinar from "./pages/management/revenueStatus/mgmtRevenueWebinar.js";

import MgmtPaidAccommodation from "./pages/management/accommodationStatus/mgmtPaidAccommodation.js";
import MgmtFreeAccommodation from "./pages/management/accommodationStatus/mgmtFreeAccommodation.js";

import MgmtRefundApproved from "./pages/management/refundStatus/mgmtRefundApproved.js";
import MgmtRefundPending from "./pages/management/refundStatus/mgmtRefundPending.js";

import MgmtTransactionStatus from "./pages/management/transactionStatus/mgmtTransactionStatus.js";
import MgmtPaypalTransactions from "./pages/management/paypalTransactions/mgmtpaypalTransactions.js";

// conference management
import AccommodationSetup from './pages/management/accommodationSetup/accommodationSetup.js';
import MgmtPendingAccommodation from './pages/management/accommodation/mgmtPendingAccommodation.js';
import MgmtVerifiedAccommodation from './pages/management/accommodation/mgmtVerifiedAccommodation.js';
import MgmtStagingAccommodation from './pages/management/accommodation/mgmtStagingAccommodation.js';
import MgmtCancelledAccommodation from './pages/management/accommodation/mgmtCancelledAccommodation.js';


const AppRoutes = () => (
  <Router>
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedRoute roles={["admin"]} />}>
        <Route path="/prCurrencyType" element={<PrCurrencyType />} />
        <Route path="/prEventType" element={<PrEventType />} />
        <Route path="/prOccupancyType" element={<PrOccupancyType />} />
        <Route path="/prRegistrationType" element={<PrRegistrationType />} />
        <Route path="/prPaymentType" element={<PrPaymentType />} />
        <Route
          path="/prRegistrationCategory"
          element={<PrRegistrationCategory />}
        />
        <Route
          path="/paymentReceiptReceived"
          element={<PaymentReceiptReceived />}
        />
        <Route
          path="/paymentReceiptGenerated"
          element={<PaymentReceiptGenerated />}
        />
        <Route path="/paymentReceiptPdf" element={<PaymentReceiptPdf />} />
        <Route
          path="/invoiceReceiptReceived"
          element={<InvoiceReceiptReceived />}
        />
        <Route
          path="/invoiceReceiptGenerated"
          element={<InvoiceReceiptGenerated />}
        />
        <Route path="/invoiceRegType" element={<InvoiceRegType />} />
        <Route path="/invoiceInBank" element={<InvoiceInBank />} />
        <Route path="/invoiceUsBank" element={<InvoiceUsBank />} />
        <Route path="/invoiceReceiptPdf" element={<InvoiceReceiptPdf />} />
        <Route path="/pendingProgramManager" element={<PendingProgramManager />} />
        <Route path="/approvedProgramManager" element={<ApprovedProgramManager />} />
        <Route path="/allreviewers" element={<AllReviewers />} />
        <Route path="/approvedreviewers" element={<ApprovedReviewers />} />
        <Route path="/pendingreviewers" element={<PendingReviewers />} />
        <Route path="/abCategory" element={<AbCategory />} />
        <Route path="/abstractType" element={<AbstractType />} />

        <Route path="/esVenue" element={<EsVenue />} />
        <Route path="/esSubjectType" element={<EsSubjectType />} />
        <Route path="/esCountries" element={<EsCountries />} />
        <Route path="/esSubdomainType" element={<EsSubdomainType />} />
        <Route path="/esSeriesType" element={<EsSeriesType />} />
        <Route path="/paidAccommodation" element={<PaidAccommodation />} />
        <Route path="/freeAccommodation" element={<FreeAccommodation />} />
        <Route path="/refundApproved" element={<RefundApproved />} />
        <Route path="/refundPending" element={<RefundPending />} />
        <Route path="/conferenceEvent" element={<ConferenceEvent />} />
        <Route path="/webinarEvent" element={<WebinarEvent />} />
        <Route path="/transactionStatus" element={<TransactionStatus />} />
        <Route path="/revenueAll" element={<RevenueAll />} />
        <Route path="/revenueConference" element={<RevenueConference />} />
        <Route path="/revenueWebinar" element={<RevenueWebinar />} />
        <Route path="/abstract" element={<Abstract />} />
        <Route path="/brochure" element={<Brochure />} />
        <Route path="/contact" element={<Contact />} />
        <Route
          path="/pastconfProceedingsLists"
          element={<PastconfProceedingsLists />}
        />

        <Route path="/registration" element={<Registration />} />
        <Route path="/selfRegistration" element={<SelfRegistration />} />
        <Route path="/paypalTransactions" element={<PaypalTransactions />} />
        <Route path="/razorpayTransactions" element={<RazorpayTransactions />} />
        <Route path="/cmsUser" element={<CmsUser />} />
        <Route path="/metaTags" element={<MetaTags />} />
        <Route path="/seoContextPage" element={<SeoContextPage />} />

      </Route>
      <Route element={<ProtectedRoute roles={["event"]} />}>
        <Route path="/programManager" element={<ProgramManager />} />
        <Route path="/abreviewers" element={<Abreviewers />} />
        <Route path="/abstractReceipt" element={<AbstractReceipt />} />
        <Route path="/abstractReceiptPdf" element={<AbstractReceiptPdf />} />

        <Route path="/embrochure" element={<EmBrochure />} />
        <Route path="/emabstract" element={<EmAbstract />} />
        <Route path="/emcontact" element={<EmContact />} />
        <Route
          path="/empastconfProceedingsLists"
          element={<EmPastconfProceedingsLists />}
        />

        <Route path="/emregistration" element={<EmRegistration />} />
        <Route path="/emselfRegistration" element={<EmSelfRegistration />} />

        <Route path="/paymentReceipt" element={<PaymentReceipt />} />
        <Route path="/invoiceReceipt" element={<InvoiceReceipt />} />

        <Route path="/refund" element={<Refund />} />
        <Route path="/accommodation" element={<Accommodation />} />
        <Route path="/dashboard" element={<Dashboard />} />

      </Route>
      <Route element={<ProtectedRoute roles={["finance"]} />}>
          <Route path="/revenue" element={<Revenue />} />
      </Route>
      <Route element={<ProtectedRoute roles={["management"]} />}>
        <Route path="/mgmtPrCurrencyType" element={<MgmtPrCurrencyType />} />
        <Route path="/mgmtPrEventType" element={<MgmtPrEventType />} />
        <Route path="/mgmtPrOccupancyType" element={<MgmtPrOccupancyType />} />
        <Route path="/mgmtPrRegistrationType" element={<MgmtPrRegistrationType />} />
        <Route path="/mgmtPrPaymentType" element={<MgmtPrPaymentType />} />
        <Route path="/mgmtPrRegistrationCategory" element={<MgmtPrRegistrationCategory />}/>
        <Route path="/mgmtPaymentReceiptReceived" element={<MgmtPaymentReceiptReceived />} />
        <Route path="/mgmtPaymentReceiptGenerated" element={<MgmtPaymentReceiptGenerated />} />
        <Route path="/mgmtPaymentReceiptPdf" element={<MgmtPaymentReceiptPdf />} />

        <Route path="/mgmtInvoiceReceiptReceived" element={<MgmtInvoiceReceiptReceived />} />
        <Route path="/mgmtInvoiceReceiptGenerated" element={<MgmtInvoiceReceiptGenerated />}/>
        <Route path="/mgmtInvoiceRegType" element={<MgmtInvoiceRegType />} />
        <Route path="/mgmtInvoiceInBank" element={<MgmtInvoiceInBank />} />
        <Route path="/mgmtInvoiceUsBank" element={<MgmtInvoiceUsBank />} />
        <Route path="/mgmtInvoiceReceiptPdf" element={<MgmtInvoiceReceiptPdf />} />

        <Route path="/mgmtPaidAccommodation" element={<MgmtPaidAccommodation />} />
        <Route path="/mgmtFreeAccommodation" element={<MgmtFreeAccommodation />} />

        <Route path="/mgmtRefundApproved" element={<MgmtRefundApproved />} />
        <Route path="/mgmtRefundPending" element={<MgmtRefundPending />} />

        <Route path="/mgmtTransactionStatus" element={<MgmtTransactionStatus />} />
        <Route path="/MgmtPaypalTransactions" element={<MgmtPaypalTransactions />} />
        
        <Route path="/mgmtRevenueAll" element={<MgmtRevenueAll />} />
        <Route path="/mgmtRevenueConference" element={<MgmtRevenueConference />} />
        <Route path="/mgmtRevenueWebinar" element={<MgmtRevenueWebinar />} />

        <Route path="/accommodationSetup" element={<AccommodationSetup />} />
        <Route path="/mgmtPendingAccommodation" element={<MgmtPendingAccommodation />} />
        <Route path="/mgmtVerifiedAccommodation" element={<MgmtVerifiedAccommodation />} />
        <Route path="/mgmtStagingAccommodation" element={<MgmtStagingAccommodation />} />
        <Route path="/mgmtCancelledAccommodation" element={<MgmtCancelledAccommodation />} />

      </Route>
      {/* <Route path="/pdf" element={<Pdf />} /> */}
    </Routes>
  </Router>
);

export default AppRoutes;
